export default function validate(values, stepIndex, translations, fetching) {
  if (fetching) return;
  const errors = {};
  if (stepIndex === 0 && !values.landskap) {
    errors.landskap = translations[0].i18n.errors.province;
  }
  if (stepIndex === 0 && !values.kvm) {
    errors.kvm = translations[0].i18n.errors.province;
  }
  if (stepIndex === 0 && Number(values.kvm) < Number(values.min_order)) {
    errors.kvm = translations[0].i18n.errors.min + values.min_order;
  }
  if (stepIndex === 0 && Number(values.kvm) > 4000) {
    errors.kvm = translations[0].i18n.errors.max;
  }
  if (stepIndex === 0 && !values.antal_plan) {
    errors.antal_plan = translations[0].i18n.errors.floors;
  }
  if (stepIndex === 0 && !values.lutning) {
    errors.lutning = translations[0].i18n.errors.inclination;
  }
  if (stepIndex === 0 && !values.farg) {
    errors.farg = translations[0].i18n.errors.color;
  }
  if (stepIndex === 1 && !values.namn) {
    errors.namn = translations[0].i18n.errors.name;
  }
  if (stepIndex === 1 && !values.adress) {
    errors.adress = translations[0].i18n.errors.address;
  }
  if (stepIndex === 1 && !values.postnr) {
    errors.postnr = translations[0].i18n.errors.zip;
  }
  if (stepIndex === 1 && !values.ort) {
    errors.ort = translations[0].i18n.errors.city;
  }
  if (stepIndex === 1) {
    if (!values.epost) {
      errors.epost = translations[0].i18n.errors.email;
    } else if (!/\S+@\S+\.\S+/.test(values.epost)) {
      errors.epost = translations[0].i18n.errors.invalid;
    }
  }
  if (stepIndex === 1 && !values.telefon) {
    errors.telefon = translations[0].i18n.errors.phone;
  }
  if (stepIndex === 1 && values.terms === false) {
    errors.terms = translations[0].i18n.errors.terms;
  }
  if (stepIndex === 1 && values.gdpr === false) {
    errors.gdpr = translations[0].i18n.errors.gdpr;
  }
  if (stepIndex === 1 && values.recaptcha === null) {
    errors.recaptcha = translations[0].i18n.errors.recaptcha;
  }
  return errors;
}
